// src/components/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// requiredPermission puede ser un string o un array de strings (acceso con cualquiera de ellos)
const ProtectedRoute = ({ requiredPermission }) => {
  const { isLoggedIn, hasPermission, user } = useContext(AuthContext);

  if (!isLoggedIn) {
    // Si no está logueado, redirige a la página de login
    return <Navigate to="/login" replace />;
  }

  // Si se requiere un permiso específico y el usuario no lo tiene
  if (requiredPermission) {
    const permsToCheck = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
    const hasAny = permsToCheck.some(p => hasPermission(p));
    if (!hasAny) {
      // Redirigir según el rol del usuario (evitar bucles)
      const isAdmin = user?.role === 'superadmin' || hasPermission('ver_dashboard');
      return <Navigate to={isAdmin ? '/admin' : '/login'} replace />;
    }
  }

  // Si está logueado y tiene los permisos, renderiza el componente hijo
  return <Outlet />;
};

export default ProtectedRoute;